import React, { useRef, useEffect} from 'react';
import ReactDOM from 'react-dom';

import { Box, Grid } from '@material-ui/core';

import SocketProvider from '@user-provider/SocketProvider';
import AudioPlayer from '@user-pages/exercise/common/AudioPlayer'
import MeasureHelper from '@helper/MeasureHelper'
import { useParams } from "react-router-dom";
import ExerciseStatusBar from "../ExerciseStatusBar";
import ActiveProgress from "../common/ActiveProgress";
const { measureTypeToCode } = MeasureHelper

let MeasureHzType
const MeasureSettings = {
    'breath' :  {
        url : 'https://d2iajcsshqwtw3.cloudfront.net/assets/breath2.webm',
        poster : 'https://d2iajcsshqwtw3.cloudfront.net/assets/poster/breath2.png',
        loopTime: 40,
        headTime: 0,
        activeBar: true,
        showSpeed: false,
    },
    'balloon' :  {
        url: 'https://d2iajcsshqwtw3.cloudfront.net/assets/breathStamp.webm',
        poster : 'https://d2iajcsshqwtw3.cloudfront.net/assets/poster/breathStamp.png',
        loopTime: 0,
        headTime: 0,
        activeBar: false,
        showSpeed: true,
    },
    'cross' :  {
        url: 'https://d2iajcsshqwtw3.cloudfront.net/assets/breathCross.webm',
        poster : 'https://d2iajcsshqwtw3.cloudfront.net/assets/poster/breathCross.png',
        loopTime: 40,
        headTime: 0,
        activeBar: true,
        showSpeed: false,
    },
    'nature' :  {
        url: 'https://d2iajcsshqwtw3.cloudfront.net/assets/breathNature.webm',
        loopTime: 0,
        headTime: 0,
        activeBar: true,
        showSpeed: false,
    },
}


const Breath = (props) => {
    const stageRef = useRef()
    let currentMeasureType = 'rest'
    let currentMeasureCode = 'A'
    
    const { type } = useParams()
    MeasureHzType = type ? type : 'breath'
    
    useEffect(()=>{
        SocketProvider.connect(()=>{}, window, MeasureHzType)

        return () => {
            SocketProvider.measureStop(true).then()
        }
    },[])

    const startExercise = async (runningTime, measureType, measureCode) => {
        stageRef.current.setAudioMode(measureType)
        await SocketProvider.measureStart(runningTime,0, MeasureHzType, measureType, measureTypeToCode(measureType), measureCode)
    }

    const stopExercise = async () => {
        await SocketProvider.measureStop(false, true)
    }

    //측정 완료메세지를 받으면 
    SocketProvider.onMeasureStop = async () => {}
    
    return (
        <Box style={{position: 'relative', overflow:'hidden'}}>
            <ExerciseStatusBar
                measureHzType={MeasureHzType}
                measureType={currentMeasureType}
                measureCode={currentMeasureCode}
                close={async () => {
                    await stopExercise()
                }}
                start={async (runningTime, measureType, measureCode) => {
                    await startExercise(runningTime, measureType, measureCode)
                }}
                pause={(isPause) => {

                }}
            />
            
            <Stage
                ref={stageRef}
                history={props.history}
            />
        </Box>
    );
}

export class Stage extends React.Component {
    container
    clientRect

    videoTimer
    videoRef = React.createRef()
    audioRef = React.createRef()
    actionBoxRef = React.createRef()
    
    hitCount = 0
    
    constructor(props) {
        super(props)
        this.state = {
            hitCount: 0,
            onMeasureData: props.onMeasureData,
            onReset: props.onReset,
            history: props.history
        }
    }

    setAudioMode(measureType){
        this.audioRef.current.setMode(measureType)
    }

    componentDidMount() {
        this.container = ReactDOM.findDOMNode(this)
        this.clientRect = this.container.getClientRects()[0]
        this.audio = ReactDOM.findDOMNode(this)

        SocketProvider.onMeasure = (data) => {

            if (data.isHit) {
                this.videoRef.current.play()
                this.audioRef.current.play()
                
                if(this.videoTimer) {
                    clearTimeout(this.videoTimer)
                }
                
                this.videoTimer = setTimeout(() => {
                    try {
                        this.videoRef.current.pause()    
                    } catch {}
                }, 1000)
            }
            
            try {
                this.actionBoxRef.current.update(data.isHit)    
            } catch {}
        }
    }
    
    onVideoTimeUpdate(event){
        if(this.videoRef.current.paused) {
            return false
        }

        const settings = MeasureSettings[MeasureHzType]
        const loopTime = settings.loopTime
        const headTime =  settings.headTime
        
        if(0 < loopTime && loopTime < event.target.currentTime) {
            this.videoRef.current.currentTime = headTime 
        }
    }

    render() {
        const setting = MeasureSettings[MeasureHzType]
        return (
            <Box>
                <Grid>
                    <Grid item xs={12} style={{ position: 'relative', height: window.innerHeight}}>
                        <Box style={{height:'100%'}}>
                            <video id="breath-video"
                                   ref={this.videoRef}
                                   poster={setting.poster}
                                   muted={true}
                                   onTimeUpdate={this.onVideoTimeUpdate.bind(this)}
                                   style={{height: '100%', width: '100%', objectFit: 'cover' }}>
                                <source src={setting.url} type="video/mp4"/>
                            </video>
                        </Box>
                        {setting.activeBar &&
                            <ActiveProgress ref={this.actionBoxRef} />
                        }
                    </Grid>
                </Grid>

                <AudioPlayer ref={ this.audioRef } mode={'rest'} />
            </Box>
        )
    }
}

export default Breath
